<template>
  <div>
    <b-tabs
      small
      card
      fill
      lazy
    >
      <b-tab title="Configuration">
        <b-form-group label="Select the required indicators">
          <b-form-checkbox v-model="$store.state.approvalModalCategories[approvalTypeIndex].configration.showApprovers">Approvers</b-form-checkbox>
          <b-form-checkbox v-model="$store.state.approvalModalCategories[approvalTypeIndex].configration.showConditions">Conditions</b-form-checkbox>
          <b-form-checkbox v-model="$store.state.approvalModalCategories[approvalTypeIndex].configration.showEmail">Email</b-form-checkbox>
        </b-form-group>
        <div v-if="$store.state.approvalModalCategories[approvalTypeIndex].configration.showEmail">
          <b-form-group
            class="mt-3"
            label="Email Tags:"
          >
            <multiselect
              v-model.lazy="$store.state.approvalModalCategories[approvalTypeIndex].configration.emailTags"
              label="text"
              track-by="value"
              :options="emailTagsOptions"
              :multiple="true"
              :taggable="true"
            ></multiselect>
          </b-form-group>
          <b-form-group
            class="mt-3"
            label="Platform Setting:"
          >
            <multiselect
              v-model.lazy="$store.state.approvalModalCategories[approvalTypeIndex].configration.platformSettings"
              label="platform_variable_name"
              track-by="platform_variable_value"
              :options="platformSettingOptions"
              :multiple="true"
              :taggable="true"
            ></multiselect>
          </b-form-group>
        </div>
      </b-tab>
      <b-tab
        title="Approvers"
        v-if="$store.state.approvalModalCategories[approvalTypeIndex].configration.showApprovers"
      >
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <b-card>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Requier Approver">
                  <b-form-checkbox-group v-model="$store.state.approvalModalCategories[approvalTypeIndex].approvers.requierApprover">
                    <b-form-checkbox value="executive_approver">Requier C Suite Approver</b-form-checkbox>
                    <b-form-checkbox value="management_approver">Requier Senior Management Approver</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-navbar
                  toggleable="lg"
                  type="dark"
                  variant="light"
                >
                  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                  <b-navbar-brand
                    href="#"
                    class="text-dark"
                  >
                    <strong>Select List of Employees</strong>
                  </b-navbar-brand>

                  <b-collapse
                    id="nav-collapse"
                    is-nav
                  >
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                      <b-nav-form>
                        <b-form-group
                          label-cols-sm="3"
                          label-align-sm="right"
                          label-size="sm"
                          label-for="filterInput"
                        >
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button
                                :disabled="!filter"
                                @click="filter = ''"
                              >Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-nav-form>
                    </b-navbar-nav>
                  </b-collapse>
                </b-navbar>
                <b-table
                  bordered
                  class="mx-1"
                  sticky-header="calc(100vh - 220px)"
                  ref="table"
                  id="employee-gifts-table"
                  :busy.sync="isLoading"
                  :fields="staticFields"
                  :items="getEmployeeTableData"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                >
                  <template v-slot:cell(contact_name)="data">{{ data.item.first_name+' '+data.item.last_name }}</template>
                  <template v-slot:cell(actions)="data">
                    <b-button
                      variant="primary"
                      @click="onSelectedEmployee(data)"
                    >>>></b-button>
                  </template>
                </b-table>
                <p class="mt-3">Current Page: {{ perPage }} rows</p>
                <b-row>
                  <b-col cols="2">
                    <b-form-select
                      v-model="perPage"
                      id="perPageSelect"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </b-col>
                  <b-col>
                    <b-pagination
                      class="float-right"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                      aria-controls="employee-gifts-table"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6">
                <p>Selected Employee List</p>
                <b-table-simple
                  bordered
                  responsive="sm"
                >
                  <b-thead>
                    <b-tr>
                      <b-th>Index</b-th>
                      <b-th>Employee Name</b-th>
                      <b-th>Actions</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                      v-for="(employeeList,employeeIndex) in $store.state.approvalModalCategories[approvalTypeIndex].approvers.approversList"
                      :key="employeeIndex"
                    >
                      <b-td>{{ employeeIndex+1+'.' }}</b-td>
                      <b-td>{{ employeeList.name }}</b-td>
                      <b-td>
                        <font-awesome-icon
                          v-b-tooltip.hover
                          title="Delete"
                          icon="trash"
                          :class="'ml-2 text-danger'"
                          @click="deleteSelectedEmployee(employeeIndex)"
                        />
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
          </b-card>
        </b-overlay>
      </b-tab>
      <b-tab
        title="Conditions"
        v-if="$store.state.approvalModalCategories[approvalTypeIndex].configration.showConditions"
      >
        <b-card>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Select Currency">
                <v-select
                  label="text"
                  v-model="$store.state.approvalModalCategories[approvalTypeIndex].conditions.selectedCurrency"
                  :options="currenciesOptions"
                  @input="setCurrency"
                ></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-table-simple class="table my-2">
            <b-thead>
              <b-tr>
                <b-th scope="col">Minimum Amount {{ $store.state.approvalModalCategories[approvalTypeIndex].conditions.currencyValue ? ' ('+ $store.state.approvalModalCategories[approvalTypeIndex].conditions.currencyValue+')' : '' }}</b-th>
                <b-th scope="col">Maximum Amount {{ $store.state.approvalModalCategories[approvalTypeIndex].conditions.currencyValue ? ' ('+ $store.state.approvalModalCategories[approvalTypeIndex].conditions.currencyValue+')' : '' }}</b-th>
                <b-th scope="col">Number Of Approver</b-th>
                <b-th scope="col">Action</b-th>
              </b-tr>
            </b-thead>

            <b-tbody>
              <b-tr
                v-for="(cloenFields,cloenFieldsIndex) in $store.state.approvalModalCategories[approvalTypeIndex].conditions.maximumAmount"
                :key="cloenFieldsIndex"
              >
                <b-td style="padding-top: 0px;">
                  <div v-if="cloenFieldsIndex == 0">1</div>
                  <div v-else>{{checkFieldValue(cloenFieldsIndex)}}</div>
                </b-td>
                <b-td>
                  <b-form-group :invalid-feedback="invalidValue">
                    <b-form-input
                      v-model="$store.state.approvalModalCategories[approvalTypeIndex].conditions.maximumAmount[cloenFieldsIndex]"
                      :state="invalidValue ? false : null"
                      onkeydown="return event.keyCode !== 69"
                      @change="setArrayValue($event,cloenFieldsIndex)"
                      type="number"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                </b-td>
                <b-td>
                  <b-form-group :invalid-feedback="invalidValueNumberOfApprover">
                    <b-input
                      onkeydown="return event.keyCode !== 69"
                      :state="invalidValueNumberOfApprover ? false : null"
                      v-model="$store.state.approvalModalCategories[approvalTypeIndex].conditions.numberOfApproverValue[cloenFieldsIndex]"
                      type="number"
                      @change="setIndex($event,cloenFieldsIndex)"
                      size="sm"
                      min="31"
                      max="75"
                    ></b-input>
                  </b-form-group>
                </b-td>
                <b-td style="padding-top: 0px;">
                  <b-button
                    variant="outline-danger"
                    v-if="cloenFieldsIndex > 0"
                    size="sm"
                    @click="onDeleteAmountRow(cloenFields)"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </b-td>
              </b-tr>
              <b-tr>
                <b-td>
                  <b-button
                    :disabled="addRowButtonDisable"
                    @click="addRowInTable"
                  >Add Row</b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-tab>
      <b-tab
        title="Email"
        v-if="$store.state.approvalModalCategories[approvalTypeIndex].configration.showEmail"
      >
        <b-card>
          <b-tabs
            small
            nav-class="languages-tabs-layout"
          >
            <b-tab
              v-for="(emailLanguage,lanuageIndex) in selectedLanguage"
              :key="lanuageIndex"
              :title="emailLanguage.text"
            >
              <b-tabs
                justified
                vertical
                pills
                small
                fill
              >
                <b-tab title="New Gift Request">
                  <label class="mt-3">New Gift Request</label>
                  <div class="my-2">
                    <b-row>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(tags, tagsIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.emailTags"
                              :key="tagsIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('[['+tags.text+']]', approvalTypeIndex, emailLanguage.value, 'New Gift Request')">{{ tags.text }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(platform, platformIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.platformSettings"
                              :key="platformIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', approvalTypeIndex, emailLanguage.value, 'New Gift Request')">{{ platform.platform_variable_name }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                  <b-form-group label="Email Subject">
                    <b-form-input
                      v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].newGiftRequest.subject"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-spinner
                    v-if="newGiftRequestRender"
                    label="Spinning"
                  ></b-spinner>
                  <b-form-group
                    v-else
                    label="Email Body"
                  >
                    <wysiwyg v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].newGiftRequest.message" />
                  </b-form-group>
                </b-tab>
                <b-tab title="New Approver Request Email">
                  <label class="mt-3">New Approver Request Email</label>
                  <div class="my-2">
                    <b-row>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(tags, tagsIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.emailTags"
                              :key="tagsIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('[['+tags.text+']]', approvalTypeIndex, emailLanguage.value, 'New Approver Request Email')">{{ tags.text }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(platform, platformIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.platformSettings"
                              :key="platformIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', approvalTypeIndex, emailLanguage.value, 'New Approver Request Email')">{{ platform.platform_variable_name }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                  <b-form-group label="Email Subject">
                    <b-form-input
                      v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].newApproverRequestEmail.subject"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-spinner
                    v-if="newApproverRequestEmailRender"
                    label="Spinning"
                  ></b-spinner>
                  <b-form-group
                    v-else
                    label="Email Body"
                  >
                    <wysiwyg v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].newApproverRequestEmail.message" />
                  </b-form-group>
                </b-tab>
                <b-tab title="Approver Reminder Email">
                  <label class="mt-3">Approver Reminder Email</label>
                  <div class="my-2">
                    <b-row>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(tags, tagsIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.emailTags"
                              :key="tagsIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('[['+tags.text+']]', approvalTypeIndex, emailLanguage.value, 'Approver Reminder Email')">{{ tags.text }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(platform, platformIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.platformSettings"
                              :key="platformIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', approvalTypeIndex, emailLanguage.value, 'Approver Reminder Email')">{{ platform.platform_variable_name }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                  <b-form-group label="Email Subject">
                    <b-form-input
                      v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].approverReminderEmail.subject"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-spinner
                    v-if="approverReminderEmailRender"
                    label="Spinning"
                  ></b-spinner>
                  <b-form-group
                    v-else
                    label="Email Body"
                  >
                    <wysiwyg v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].approverReminderEmail.message" />
                  </b-form-group>
                </b-tab>
                <b-tab title="Approval Email">
                  <label class="mt-3">Approval Email</label>
                  <div class="my-2">
                    <b-row>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(tags, tagsIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.emailTags"
                              :key="tagsIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('[['+tags.text+']]', approvalTypeIndex, emailLanguage.value, 'Approval Email')">{{ tags.text }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(platform, platformIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.platformSettings"
                              :key="platformIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', approvalTypeIndex, emailLanguage.value, 'Approval Email')">{{ platform.platform_variable_name }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                  <b-form-group label="Email Subject">
                    <b-form-input
                      v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].approvalEmail.subject"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-spinner
                    v-if="approvalEmailRender"
                    label="Spinning"
                  ></b-spinner>
                  <b-form-group
                    v-else
                    label="Email Body"
                  >
                    <wysiwyg v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].approvalEmail.message" />
                  </b-form-group>
                </b-tab>
                <b-tab title="Rejected Email">
                  <label class="mt-3">Rejected Email</label>
                  <div class="my-2">
                    <b-row>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(tags, tagsIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.emailTags"
                              :key="tagsIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('[['+tags.text+']]', approvalTypeIndex, emailLanguage.value, 'Rejected Email')">{{ tags.text }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(platform, platformIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.platformSettings"
                              :key="platformIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', approvalTypeIndex, emailLanguage.value, 'Rejected Email')">{{ platform.platform_variable_name }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                  <b-form-group label="Email Subject">
                    <b-form-input
                      v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].rejectedEmail.subject"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-spinner
                    v-if="rejectedEmailRender"
                    label="Spinning"
                  ></b-spinner>
                  <b-form-group
                    v-else
                    label="Email Body"
                  >
                    <wysiwyg v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].rejectedEmail.message" />
                  </b-form-group>
                </b-tab>
                <b-tab title="Additional Info Email">
                  <label class="mt-3">Additional Info Email</label>
                  <div class="my-2">
                    <b-row>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(tags, tagsIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.emailTags"
                              :key="tagsIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('[['+tags.text+']]', approvalTypeIndex, emailLanguage.value, 'Additional Info Email')">{{ tags.text }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                      <b-col cols="6">
                        <b-card>
                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                            <span
                              v-for="(platform, platformIndex) in $store.state.approvalModalCategories[approvalTypeIndex].configration.platformSettings"
                              :key="platformIndex"
                              class="mr-2"
                            >
                              <b-badge
                                variant="success"
                                style="cursor: pointer;"
                              >
                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', approvalTypeIndex, emailLanguage.value, 'Additional Info Email')">{{ platform.platform_variable_name }}</p>
                              </b-badge>
                            </span>
                          </b-card-body>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                  <b-form-group label="Email Subject">
                    <b-form-input
                      v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].additionalInfoEmail.subject"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-spinner
                    v-if="additionalInfoEmailRender"
                    label="Spinning"
                  ></b-spinner>
                  <b-form-group
                    v-else
                    label="Email Body"
                  >
                    <wysiwyg v-model="$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguage.value].additionalInfoEmail.message" />
                  </b-form-group>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import { HTTP } from "../../../../../utils/HTTP";
export default {
  name: "AddModalComponents",
  data () {
    return {
      isLoading: false,
      currenciesOptions: [],
      totalRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "contact_name", label: "Contact Name", sortable: true },
        { key: "actions", label: "Select_employee", sortable: true },
      ],
      setInputArray: [],
      checkValue: null,
      categoryIndex: null,
      invalidValue: null,
      invalidValueNumberOfApprover: null,
      validInputField: false,
      inputValue: null,
      addRowButtonDisable: true,
      numberOfApproverIndex: null,
      newGiftRequestRender: false,
      newApproverRequestEmailRender: false,
      approverReminderEmailRender: false,
      approvalEmailRender: false,
      rejectedEmailRender: false,
      additionalInfoEmailRender: false
    };
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.getCurrenciesList();
  },
  methods: {
    setTagValue ( selectedValue, approvalTypeIndex, emailLanguageValue, emailTab ) {
      if ( emailTab == 'New Gift Request' ) {
        if ( this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].newGiftRequest.message == null ) {
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].newGiftRequest.message = selectedValue;
        } else {
          let newGiftRequest = this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].newGiftRequest.message + '' + selectedValue;
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].newGiftRequest.message = newGiftRequest;
        }
        this.newGiftRequestRender = true;
        setTimeout( () => {
          this.newGiftRequestRender = false;
        }, 100 );
      }
      if ( emailTab == 'New Approver Request Email' ) {
        if ( this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].newApproverRequestEmail.message == null ) {
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].newApproverRequestEmail.message = selectedValue;
        } else {
          let newApproverRequestEmail = this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].newApproverRequestEmail.message + '' + selectedValue;
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].newApproverRequestEmail.message = newApproverRequestEmail;
        }
        this.newApproverRequestEmailRender = true;
        setTimeout( () => {
          this.newApproverRequestEmailRender = false;
        }, 100 );
      }
      if ( emailTab == 'Approver Reminder Email' ) {
        if ( this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].approverReminderEmail.message == null ) {
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].approverReminderEmail.message = selectedValue;
        } else {
          let approverReminderEmail = this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].approverReminderEmail.message + '' + selectedValue;
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].approverReminderEmail.message = approverReminderEmail;
        }
        this.approverReminderEmailRender = true;
        setTimeout( () => {
          this.approverReminderEmailRender = false;
        }, 100 );
      }
      if ( emailTab == 'Approval Email' ) {
        if ( this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].approvalEmail.message == null ) {
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].approvalEmail.message = selectedValue;
        } else {
          let approvalEmail = this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].approvalEmail.message + '' + selectedValue;
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].approvalEmail.message = approvalEmail;
        }
        this.approvalEmailRender = true;
        setTimeout( () => {
          this.approvalEmailRender = false;
        }, 100 );
      }
      if ( emailTab == 'Rejected Email' ) {
        if ( this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].rejectedEmail.message == null ) {
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].rejectedEmail.message = selectedValue;
        } else {
          let rejectedEmail = this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].rejectedEmail.message + '' + selectedValue;
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].rejectedEmail.message = rejectedEmail;
        }
        this.rejectedEmailRender = true;
        setTimeout( () => {
          this.rejectedEmailRender = false;
        }, 100 );
      }
      if ( emailTab == 'Additional Info Email' ) {
        if ( this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].additionalInfoEmail.message == null ) {
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].additionalInfoEmail.message = selectedValue;
        } else {
          let additionalInfoEmail = this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].additionalInfoEmail.message + '' + selectedValue;
          this.$store.state.approvalModalCategories[approvalTypeIndex].emails[emailLanguageValue].additionalInfoEmail.message = additionalInfoEmail;
        }
        this.additionalInfoEmailRender = true;
        setTimeout( () => {
          this.additionalInfoEmailRender = false;
        }, 100 );
      }
    },
    async getCurrenciesList () {
      this.currenciesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/constants/currencies-list",
          null
        );
        this.currenciesOptions = result.data.currency;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getEmployeeTableData () {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let result = HTTP( "post", "api/v1/employees/get-employee-list", formData );

      return result
        .then( ( response ) => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        } )
        .catch( ( error ) => {
          this.isLoading = false;
          return [error];
        } );
    },
    setCurrency ( value ) {
      if ( value != null ) {
        this.$store.state.approvalModalCategories[
          this.approvalTypeIndex
        ].conditions.currencyValue = value.text;
      } else {
        this.$store.state.approvalModalCategories[
          this.approvalTypeIndex
        ].conditions.currencyValue = null;
      }
    },
    onSelectedEmployee ( data ) {
      this.$store.state.approvalModalCategories[
        this.approvalTypeIndex
      ].approvers.approversList.push( {
        id: data.item.id,
        email: data.item.email,
        name: data.item.first_name + " " + data.item.last_name,
        is_senior_management: data.item.is_senior_management,
        is_c_suite_officer: data.item.is_c_suite_officer,
      } );
    },
    deleteSelectedEmployee ( employeeIndex ) {
      this.$store.state.approvalModalCategories[
        this.approvalTypeIndex
      ].approvers.approversList.splice( employeeIndex, 1 );
    },
    setIndex ( data, cloenFieldsIndex ) {
      this.numberOfApproverIndex = cloenFieldsIndex;
    },
    checkFieldValue ( cloenFieldsIndex ) {
      let value = this.$store.state.approvalModalCategories[
        this.approvalTypeIndex
      ].conditions.maximumAmount[cloenFieldsIndex - 1];
      return parseInt( value ) + 1;
    },
    setArrayValue ( data, cloenFieldsIndex ) {
      this.addRowButtonDisable =
        this.$store.state.approvalModalCategories[this.approvalTypeIndex]
          .conditions.maximumAmount[cloenFieldsIndex] != null
          ? false
          : true;
      this.checkValue = data;
      this.categoryIndex = cloenFieldsIndex;
      this.setInputArray.push( data );
    },
    addRowInTable () {
      if ( this.setInputArray.length ) {
        let data = this.setInputArray[0];
        this.invalidValue = null;
        let value = this.$store.state.approvalModalCategories[
          this.approvalTypeIndex
        ].conditions.maximumAmount[this.categoryIndex - 1];
        if ( parseInt( value ) + 1 > this.checkValue ) {
          this.validInputField = true;
          this.invalidValue = "Value Can't be less then";
          this.setInputArray = [];
          return;
        }
        let approverNumberValue = this.$store.state.approvalModalCategories[
          this.approvalTypeIndex
        ].conditions.numberOfApproverValue[this.numberOfApproverIndex];
        if ( approverNumberValue < 1 || approverNumberValue > 5 ) {
          this.invalidValueNumberOfApprover = "Value More less then 5";
          return;
        }
        this.invalidValueNumberOfApprover = null;
        this.validInputField = false;
        this.$store.state.approvalModalCategories[
          this.approvalTypeIndex
        ].conditions.maximumAmount.push( parseInt( data ) + 2 );
        this.inputValue = data;
        this.setInputArray = [];
        this.addRowButtonDisable = this.addRowButtonDisable = true;
      } else {
        this.$store.state.approvalModalCategories[
          this.approvalTypeIndex
        ].conditions.maximumAmount.push(
          this.inputValue != null ? parseInt( this.inputValue ) + 2 : null
        );
        this.addRowButtonDisable = true;
        this.inputValue = null;
      }
    },
    onDeleteAmountRow ( value ) {
      let amountAndApproverIndex = this.$store.state.approvalModalCategories[
        this.approvalTypeIndex
      ].conditions.maximumAmount.indexOf( value );
      this.$store.state.approvalModalCategories[
        this.approvalTypeIndex
      ].conditions.maximumAmount.splice( amountAndApproverIndex, 1 );
      this.$store.state.approvalModalCategories[
        this.approvalTypeIndex
      ].conditions.numberOfApproverValue.splice( amountAndApproverIndex, 1 );
    },
  },
  props: {
    approvalTypeIndex: Number,
    selectedLanguage: Array,
    emailTagsOptions: Array,
    platformSettingOptions: Array
  },
};
</script>
<style>
.languages-tabs-layout {
  width: 50rem;
  transform: translateX(13rem);
}
</style>